import { createContext, RefObject, useRef, useState } from 'react'

import { DELAY } from '@/constants'

type HoverElementPropsType = {
  children: React.ReactElement
}

export type HoverElementContextType = {
  open: boolean
  containerRef: RefObject<HTMLDivElement>
  setOpen: (open: boolean) => void
  handleMouseEnter: () => void
  handleMouseLeaveContainer: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void
  handleSelectBlur: () => void
}

export const HoverElementContext =
  createContext<null | HoverElementContextType>(null)

function HoverElement(props: HoverElementPropsType) {
  const { children } = props

  const [open, setOpen] = useState<boolean>(false)

  const containerRef = useRef<HTMLDivElement>(null)
  const leaveTimeout = useRef<NodeJS.Timeout | null>(null)

  const handleMouseEnter = () => {
    clearTimeout(leaveTimeout.current as NodeJS.Timeout)
    setTimeout(() => {
      setOpen(true)
    }, DELAY / 5)
  }

  const handleMouseLeaveContainer = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    leaveTimeout.current = setTimeout(() => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.relatedTarget as Node)
      ) {
        setOpen(false)
      }
    }, DELAY / 5)
  }

  const handleSelectBlur = () => {
    if (containerRef.current && !containerRef.current.matches(':hover')) {
      setOpen(false)
    }
  }

  return (
    <HoverElementContext.Provider
      value={{
        open,
        containerRef,
        setOpen,
        handleMouseEnter,
        handleMouseLeaveContainer,
        handleSelectBlur,
      }}
    >
      {children}
    </HoverElementContext.Provider>
  )
}

export default HoverElement
